import type { LayerState } from '@vitals/shared';
import type { VitalDef } from './vitals.js';

/**
 * Vital selector for airborne rotorcraft overhead.
 *
 * Display: value = helicopter count, label "helicopters".
 * Backed by the existing 'flights' layer summary.
 */
export const helicoptersVital: VitalDef = {
  id: 'helicopters',
  layerId: 'flights',

  select(s: LayerState | undefined) {
    const isDown = !s || s.status === 'down' || s.summary == null;
    if (isDown) {
      return {
        value: '—',
        label: 'helicopters',
        down: true,
        stale: false,
      };
    }

    const stale = s.status === 'stale';
    const { helicopters } = s.summary as { helicopters: number };

    return {
      value: `${helicopters}`,
      label: 'helicopters',
      down: false,
      stale,
    };
  },
};
